module.exports = __webpack_public_path__ + "static/media/mastercard.01ae1020.svg";